import Service from './Service';
import DialogService from './DialogService';
import ServiceFaker from '-/services/ops/Faker';
import {set as lodashSet} from '-/util/lodash';
import config from '-/config/config';

const {defaultVehicleInfoType} = config;
const VEHICLEINFO_RESETDATA = 'VEHICLEINFO_RESETDATA';
const VEHICLEINFO_SET = 'VEHICLEINFO_SET';
const VEHICLEINFO_UNSET = 'VEHICLEINFO_UNSET';
const VEHICLEINFO_SETDATA = 'VEHICLEINFO_SETDATA';
const VEHICLEINFO_VIN_PHOTO_UPLOAD = 'VEHICLEINFO_VIN_PHOTO_UPLOAD';
const VEHICLEINFO_VEHICLE_INFO_SELECT = 'VEHICLEINFO_VEHICLE_INFO_SELECT';
const VEHICLEINFO_ACCESSORIES_SET = 'VEHICLEINFO_ACCESSORIES_SET';

const reducerName = 'vehicleInfo';

const initialState = {
    vehicleInfoType: defaultVehicleInfoType,
    ...ServiceFaker.vehicleInfo
};

const set = (state, key, value) => {
    const newState = {...state};

    lodashSet(newState, key, value);

    return newState;
};

const unset = (state, key) => {
    const newState = {...state};
    delete newState[key];

    return newState;
};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case VEHICLEINFO_RESETDATA: {
            return {
                ...payload
            };
        }
        case VEHICLEINFO_SETDATA: {
            return {
                ...state,
                ...payload
            };
        }
        case VEHICLEINFO_SET: {
            const {key, value} = payload;
            return set(state, key, value);
        }
        case VEHICLEINFO_UNSET: {
            const {key} = payload;
            return unset(state, key);
        }
        case VEHICLEINFO_VIN_PHOTO_UPLOAD: {
            const {
                vinImagePath,
                vinImageDataURL
            } = payload;
            return {
                ...state,
                vinImagePath,
                vinImageDataURL
            };
        }
        case VEHICLEINFO_VEHICLE_INFO_SELECT:
            return {
                ...state,
                ...payload
            };
        case VEHICLEINFO_ACCESSORIES_SET: {
            const {value} = payload;
            return {
                ...state,
                bookout: {
                    accessories: value
                }
            };
        }
    }
    return state;
};

class VehicleInfoService extends Service {
    constructor() {
        super();

        if (!VehicleInfoService.instance) {
            VehicleInfoService.instance = this;
        }
        return VehicleInfoService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    closeDialog() {
        DialogService.show(false);
    }

    openDialog(data, callback) {
        DialogService.show('VinReminder', data, callback);
    }

    photoUpload(vinImagePath, vinImageDataURL) {
        this.store.dispatch({
            type: VEHICLEINFO_VIN_PHOTO_UPLOAD,
            payload: {
                vinImagePath,
                vinImageDataURL
            }
        });
    }

    vehicleInfoSelect(value) {
        this.store.dispatch({
            type: VEHICLEINFO_VEHICLE_INFO_SELECT,
            payload: value
        });
    }

    set(key, value) {
        this.store.dispatch({
            type: VEHICLEINFO_SET,
            payload: {
                key,
                value
            }
        });

        if (key === 'make') {
            this.set('makeDesc', value);
        } else if (key === 'model') {
            this.set('modelDesc', value);
        }
    }

    unset(key) {
        this.store.dispatch({
            type: VEHICLEINFO_UNSET,
            payload: {key}
        });
    }

    resetData() {
        this.store.dispatch({
            type: VEHICLEINFO_RESETDATA,
            payload: initialState
        });
    }

    setAccessories(value = []) {
        this.store.dispatch({
            type: VEHICLEINFO_ACCESSORIES_SET,
            payload: {
                value
            }
        });
    }

    setData(vehicleInfo) {
        this.store.dispatch({
            type: VEHICLEINFO_SETDATA,
            payload: vehicleInfo
        });
    }

    getDataForSave() {
        let obj = {...this.getReducerState()};
        if (obj.vinImageDataURL) {
            delete obj.vinImageDataURL;
        }
        if (obj.vin && obj.vin.length !== 17) {
            delete obj.vin;
        }
        return obj;
    }

    setExperianData(data) {
        const fieldMap = {
            lienholder: 'lienholder.company.name',
            plateNumber: 'licensePlate.number',
            plateState: 'licensePlate.state'
        };

        Object.keys(fieldMap).forEach(key => {
            const value = data[key];
            const field = fieldMap[key];

            if (value) {
                this.set(field, value);
            }
        });
    }
}

export default new VehicleInfoService();
